export default () => ({
  shoppingCart: {
    user: {},
    tempUser: {},
    products: [],
  },
});
